exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.rounded-card[data-v-a5c40aae]{\n    border-radius: 4px !important;\n}\n.width[data-v-a5c40aae] {\n    width: 256px;\n}\n\n", ""]);
